import { requestWithAuth } from '@/utilities/graphQLClient';
import { gql } from 'graphql-request';

import type {
  Holding,
  Portfolio,
  UnmatchedHolding,
} from '@/hooks/portfolio/usePortfolio';
import { PORTFOLIO_FRAGMENT } from '@/hooks/portfolio/usePortfolio';

type Response =
  | { errors: Error[] }
  | {
      removeHolding: Portfolio;
    };

export const removeHoldingQueryFn = async (payload: {
  id: Holding['id'] | UnmatchedHolding['id'];
}) => {
  const { id } = payload;
  const response = await requestWithAuth<Response>(
    gql`
      mutation removeHolding($id: String!) {
        removeHolding(id: $id) {
          ...portfolioFields
        }
      }
      ${PORTFOLIO_FRAGMENT}
    `,
    {
      id,
    }
  );

  if ('removeHolding' in response) {
    return response.removeHolding;
  }

  const [firstError] = response.errors;

  throw new Error(firstError?.message ?? 'Failed to remove the holding');
};
